import placesSaga from './placesSaga'
import filesSaga from './filesSaga'
import workHistorySaga from './workHistory'
import educationSaga from './education'
import skillsSaga from './skills'
import jobExperiencesSaga from './jobExperiencesSaga'
import { watchCandidateSaga } from './candidateSaga'

export default () => [
  placesSaga(),
  watchCandidateSaga(),
  filesSaga(),
  workHistorySaga(),
  educationSaga(),
  skillsSaga(),
  jobExperiencesSaga(),
]
